import { ActionStatus } from '@common/constants/shared';
import { setResetPassword } from '@common/redux/slice/action';
import { loginSuccess } from '@common/redux/slice/auth';
import store from '@common/redux/store';
import { MetadataAction } from '@common/types/action';
import { get } from 'lodash';
import { ActionResponse } from '../excuteAction';
import { registerFCMUser, unregisterFCMUser } from './FCMregister';

export const signIn: (
  action: Record<string, any>,
  metadata: MetadataAction
) => Promise<ActionResponse> = async (
  action: Record<string, any>,
  metadata: MetadataAction
) => {
  const dispatch = store.dispatch;
  const { messages } = metadata;

  if (action.status === ActionStatus.ERROR) {
    return {
      status: ActionStatus.FAILED,
      message: `Error: ${get(action, 'error.message')}`,
    };
  }
  const response = get(action, 'response.userPreview');
  const state: any = store.getState();
  await unregisterFCMUser(); //remove old token
  await registerFCMUser(response, state.appInfo.app?.id);
  dispatch(loginSuccess({ user: response }));
  if (response?.password_expired) {
    dispatch(setResetPassword({ state: true, animation: 'fadeInUpBig' }));
  }

  return {
    status: ActionStatus.SUCCESS,
    message: messages['auth_loginSuccess'],
    accessToken: action?.response?.accessToken,
    profile: response,
  };
};
